export const CATEGORY_LABELS = {
  payment: 'Payment',
  oauth: 'OAuth',
  email: 'Email',
  redis: 'Redis',
  storage: 'Storage',
  'feature-flag': 'Feature Flags',
  url: 'URLs',
  misc: 'Misc',
  bootstrap: 'Bootstrap',
  database: 'Database',
  custom: 'Custom',
};

export const CATEGORY_OPTIONS = Object.keys(CATEGORY_LABELS);

export const categoryLabel = category => CATEGORY_LABELS[category] || category || 'Uncategorized';
